import CryptoJs from 'crypto-js'

function get(key) {
    let raw = window.localStorage.getItem(key)
    if(!raw) return null
    let bytes = CryptoJs.AES.decrypt(raw, process.env.VUE_APP_CRYPTO_SECRET)
    let decrypted = bytes.toString(CryptoJs.enc.Utf8)
    return JSON.parse(decrypted)
}

function getSession() {
    let raw = window.localStorage.getItem('session')
    if(!raw) return null
    let bytes = CryptoJs.AES.decrypt(raw, process.env.VUE_APP_CRYPTO_SECRET)
    let decrypted = JSON.parse(bytes.toString(CryptoJs.enc.Utf8))
    delete decrypted.token
    return decrypted
}

function remove(key) {
    window.localStorage.removeItem(key)
}

function set(key, value) {
    let encrypted = CryptoJs.AES.encrypt(JSON.stringify(value), process.env.VUE_APP_CRYPTO_SECRET)
    window.localStorage.setItem(key, encrypted);
}

export default {
    set, get, getSession, remove
}